/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_TrialingInputs */

const zh_status_trialing = /** @type {(inputs: Status_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用中`)
};

const en_status_trialing = /** @type {(inputs: Status_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trialing`)
};

const es_status_trialing = /** @type {(inputs: Status_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En prueba`)
};

/**
* | output |
* | --- |
* | "Trialing" |
*
* @param {Status_TrialingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_trialing = /** @type {((inputs?: Status_TrialingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_TrialingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_trialing(inputs)
	if (locale === "en") return en_status_trialing(inputs)
	return es_status_trialing(inputs)
});